module.exports = __webpack_public_path__ + "static/media/duplicate.37dcb964.svg";